const facettedSearchWidget = require('../../_utilities/facettedsearchwidget');

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'categories',
    component: 'categories',
    reducer: reducer(),
  })
    .then(facettedSearchWidget('categories'))
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/categories/categories.js